let env = process.env.NODE_ENV || "dev";
console.log("build/config/env: ", env);

// 回溯服务
const envbbBaseURL = {
  dev: "https://admintcc.ekcib.com", // 回溯测试服务
  test: "https://admintcc.ekcib.com", // 回溯测试服务
  test2: "https://admintcc2.ekcib.com", // 回溯测试2服务
  uat: "https://tcc.ekcib.com", // 回溯uat服务
  production: "https://cloud.ekcib.com", // 回溯生产服务
};

// 中台官网域名
const envCHomeBaseURL = {
  dev: "https://dev.ekcib.com/", // 唐中台测试服务
  test: "https://test.ekcib.com/", // 中台测试服务
  // test2: "https://uat.ekcib.com/", // 中台测试2服务
  uat: "https://uat.ekcib.com/admin/", // 中台uat服务
  production: "https://cloud.ekcib.com", // 中台生产服务
};

// 中台服务
const envCapiBaseURL = {
  dev: "https://dev.ekcib.com/", // 唐中台测试服务 https://admintcc.ekcib.com
  test: "https://test.ekcib.com/", // 中台测试服务
  // test2: "https://admintcc2.ekcib.com", // 中台测试2服务
  uat: "https://uat.ekcib.com/admin/", // 中台uat服务
  production: "https://cloud.ekcib.com", // 中台生产服务
};

// 中台模板oss域名
const envCapiOss = {
  dev: "https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // 测试中台oss
  test: "https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // 测试中台oss
  test2: "https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // 测试中台oss
  uat: "https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // uar中台oss
  production: "https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // 生产中台oss
};

// 微信服务
const envBaseURL = {
  dev: "https://testapi.bdtbw.com", // 本地微信后台服务
  test: "https://testapi.bdtbw.com", // 测试环境微信后台服务
  test2: "https://testapi.bdtbw.com:6443", // 测试环境2微信后台服务
  uat: "https://uat.bdtbw.com", // uat环境微信后台服务
  production: "https://www.bdtbw.com", // 生产环境微信后台服务
};

// 服务号
const envWxServiceURL = {
  dev: "https://testapi.bdtbw.com/h5/#", // 服务号测试环境
  test: "https://testapi.bdtbw.com/h5/#", // 服务号测试环境
  test2: "https://testapi.bdtbw.com:6443/h5/#", // 服务号测试环境
  uat: "https://uat.bdtbw.com/h5/#", // 服务号uat环境
  production: "https://www.bdtbw.com/mobile/#", // 服务号生产环境
};

// 新版H5域名
const envNewH5BaseURL = {
  dev: "https://testapi.bdtbw.com/mixed/#", // 本地新H5测试环境
  test: "https://testapi.bdtbw.com/mixed/#", // 测试环境新H5
  test2: "https://testapi.bdtbw.com:6443/mixed/#", // 测试环境新H5
  uat: "https://uat.bdtbw.com/mixed/#", // uat环境新H5
  production: "https://www.bdtbw.com/mixed/#", // 生产环境新H5
};

// 图片域名资源文件
const envImgBaseURL = {
  dev: " https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // 本地图片服务器
  test: " https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // 测试图片服务器
  test2: " https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // 测试图片服务器
  uat: " https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // uat图片服务器
  production: " https://cib-zhongtai.oss-cn-beijing.aliyuncs.com", // 生产图片服务器
};

const envCapiOssURL = envCapiOss[env];
const baseURL = envBaseURL[env];
const wxServiceURL = envWxServiceURL[env];
const newH5BaseURL = envNewH5BaseURL[env];
const imgBaseURL = envImgBaseURL[env];
const chomeBaseURL = envCHomeBaseURL[env];
const bbApiBaseURL = envbbBaseURL[env];

module.exports = {
  envCapiOssURL,
  baseURL,
  wxServiceURL,
  newH5BaseURL,
  imgBaseURL,
  chomeBaseURL,
  bbApiBaseURL
};



//////////////////
// WEBPACK FOOTER
// ./build/config.js
// module id = c0zf
// module chunks = 51